module.exports = __webpack_public_path__ + "img/spain-stomach-cancer-female.01d514c8.png";